<app-topbar></app-topbar>
<app-create-admin></app-create-admin>
<div class="container mr-top-40" *ngIf = "divReady">
    <h1 class="mainhdng mr-bttm-30">Products & Subscriptions</h1>			
    <a href="javascript:void(0)" routerLink="/subscriptions" class="gobck gobckpaydetail"><img src="assets/images/gobck.png"> Go Back</a>
	 <div class="text-left my-4">
                <h6 class="sucssheading ordernumber clrblck text-left mr-top-10">Payment Settings</h6>
        </div>
	<div class="row d-flex align-items-center forbod py-3 m-0">
          <div class="col-md-1 col-sm-2 nopd-lftrt logomobset">
                <img src="{{product_image_url}}{{productIcon}}">
            </div>
          <div class="col-2 mr-top-10 logotextright">
                <h3 class="prdctname clrblck">{{productName}}</h3>
                <!-- <p class="boxpara">From {{subscription['subscription_start_date']}}</p> -->
            </div>
          <div class="col-md-3">
                    <p  class="boxpara"><img src="assets/images/licenses.png" class="prdoctlftimg"> {{licenseCount}} {{licenseCount > 1 ? 'Licenses' : 'License'}}</p>
                </div>
         <div class="col-md-3">
                    <p *ngFor = "let card of cardListWorking;let j = index" class="boxpara" [class]="{'marginLeftCard' : (j != '0')}"><img *ngIf = "j == 0" src="assets/images/card_back.png" class="prdoctlftimg" > {{card.card_brand}} *{{card.card_last4}}</p>
                </div>
           <div class="col-md-3">
                    <a href="javascript:void(0)" class="rmbrme clrblue changeCardBtn" data-toggle="modal" data-target="#changeCard"  (click) = "selectCard()">Change Card for all licenses</a>
                </div>
        </div>
     <div class="common">
      
        <!-- Payment Settings -->
        <div class="common cstm_lcn_div">
            <h6 class="formheading mr-top-0 mr-bttm-0 manl mb-4">Manage Licenses</h6>
        </div>
       
        <div class="common frMbl mr-bttm-40">
         <div class="table-responsive table-borderless roundbor managelicdesktop">
            <table class="table cstm_tble_lcns cstm_tble_lcnsnew">
                <thead>
                <tr class="thead">
                    <th class="prdct_pay">Store</th>
                    <th class="prdct_pay">Admin User</th>
                    <th class="prdct_pay">Plan</th>
                    <th class="prdct_pay">Paid with</th>
                    <th class="prdct_pay">Next Billing Date</th>
                    <th class="prdct_pay">Status</th>
                   
                </tr>
                </thead>
                <tbody>
                <tr *ngFor = "let license of allottedLicenses" [class] = "license.store_name == 'Not Allotted' ? 'hide_tr' : ''">
                    
                    <td class="boxpara"> {{license.store_name}}</td>
                    <td class="boxpara"> {{license.first_name}} {{license.last_name}} </td>
                    <td class="boxpara"> {{license.package_name}} plan, {{license.package_interval}}ly payment<span *ngIf = "license.free_trial_active == '1' && license.status == 'ACTIVE'" class="free_plan_txt">Free Plan till {{license.next_billing}}</span>
					<div *ngIf = "license.status == 'ACTIVE'">
                            <span class="d-block" *ngIf = "license.package_downgrade">Plan change request in progress</span>
                            <div *ngIf = "license.next_billing_date && !license.package_downgrade" class="ulfrst">
                               
                                <div class="rmbrme clrblue clps_btn" style="white-space: nowrap;" data-toggle="collapse" [attr.data-target] = "'#paymentul_first'+license.id">
                                    <div *ngIf = "license.store_name == 'Not Allotted' ">Cancel subscription</div>
                                    <div *ngIf = "license.store_name != 'Not Allotted' ">Upgrade or cancel subscription</div>
                                </div>
                                <ul [id]="'paymentul_first'+license.id" class="collapse cstm_collapse">
                                    <li [class] = "license.store_name == 'Not Allotted' ? 'hide_trr rmbrme clrblue' : 'rmbrme clrblue'" data-toggle="modal" data-target="#upgradePlan" (click) ="changePlan(license.id,license.free_trial_active)">Upgrade subscription</li>
                                    <li class="rmbrme clrblue" (click) = "cancelSubscription(license.id)">Cancel</li>
                                </ul>
                            
                            </div>

                            <div [class] = "license.store_name == 'Not Allotted' ? 'hide_trr ulfrst' : 'ulfrst'">
                               
                                <div class="rmbrme clrblue clps_btn" style="white-space: nowrap;" data-toggle="collapse" [attr.data-target] = "'#admin_user'+license.id">Change or add admin user</div>
                                <ul [id]="'admin_user'+license.id" class="collapse cstm_collapse">
                                    <li class="rmbrme clrblue" (click) ="changeAdminUser(license.id)" data-toggle="modal" data-target="#changeAdminUser">Change admin user</li>
                                    <li class="rmbrme clrblue" data-toggle="modal" data-target="#adminUser" (click) ="addAdmin()">Add admin user</li>
                                </ul>
                            
                            </div>
                           
                        </div></td>
                    <td class="boxpara"><span class="d-block">{{license.card_type}} *{{license.card_number}}</span><a href="javascript:void(0)" class="rmbrme clrblue changeCardBtn d-block" data-toggle="modal" data-target="#changeCard"  (click) = "selectCardSingle(license.id)" *ngIf="license.status == 'ACTIVE'">Change Card</a></td>
                    <td class="boxpara"> {{license.next_billing}}</td>
                    <td class="boxpara"><span class="text-danger" *ngIf="license.payment_decline ; else status">Payment Declined, Change Card</span><ng-template #status>{{license.status}}</ng-template></td>
                   
                </tr>
                </tbody>
            </table>
         </div>
			<!---Mobile Section Start--->
			<div class="mobile-subscription">
				<div *ngFor = "let license of allottedLicenses" [class] = "license.store_name == 'Not Allotted' ? 'hide_tr newmobilehide_tr ' : 'newmobilehide_tr'">
                    
                    <div class="col-md-12"><b>Store</b><br/> {{license.store_name}} </div>
                    <div class="col-md-12"><b>Admin User</b><br/> {{license.first_name}} {{license.last_name}}  </div>
                    <div class="col-md-12"><b>Plan</b><br/>{{license.package_name}} plan, {{license.package_interval}}ly payment<span *ngIf = "license.free_trial_active == '1' && license.status == 'ACTIVE'" class="free_plan_txt">Free Plan till {{license.next_billing}}</span>
					 <div *ngIf = "license.status == 'ACTIVE'">
                            <span class="d-block" *ngIf = "license.package_downgrade">Plan change request in progress</span>
                            <div *ngIf = "license.next_billing_date && !license.package_downgrade" class="ulfrst">
                               
                                <div class="rmbrme clrblue clps_btn" style="white-space: nowrap;" data-toggle="collapse" [attr.data-target] = "'#paymentul_first'+license.id">Upgrade or cancel subscription</div>
                                <ul [id]="'paymentul_first'+license.id" class="collapse cstm_collapse">
                                    <li class="rmbrme clrblue" data-toggle="modal" data-target="#upgradePlan" (click) ="changePlan(license.id,license.free_trial_active)">Upgrade subscription</li>
                                    <li class="rmbrme clrblue" (click) = "cancelSubscription(license.id)">Cancel</li>
                                </ul>
                            
                            </div>

                            <div class="ulfrst">
                               
                                <div class="rmbrme clrblue clps_btn" style="white-space: nowrap;" data-toggle="collapse" [attr.data-target] = "'#admin_user'+license.id">Change or add admin user</div>
                                <ul [id]="'admin_user'+license.id" class="collapse cstm_collapse">
                                    <li class="rmbrme clrblue" (click) ="changeAdminUser(license.id)" data-toggle="modal" data-target="#changeAdminUser">Change admin user</li>
                                    <li class="rmbrme clrblue" data-toggle="modal" data-target="#adminUser" (click) ="addAdmin()">Add admin user</li>
                                </ul>
                            
                            </div>
                           
                        </div>
					</div>
					<div class="col-md-12"><b>Paid with</b><br/><span class="d-block">{{license.card_type}} *{{license.card_number}}</span><a href="javascript:void(0)" class="rmbrme clrblue changeCardBtn d-block" data-toggle="modal" data-target="#changeCard"  (click) = "selectCardSingle(license.id)" *ngIf="license.status == 'ACTIVE'">Change Card</a> </div>
					<div class="col-md-12"><b>Next Billing Date</b><br/>  {{license.next_billing}} </div>
					<div class="col-md-12"><b>Status</b><br/> <span class="text-danger" *ngIf="license.payment_decline ; else status">Payment Declined, Change Card</span><ng-template #status>{{license.status}}</ng-template> </div>
                   
                </div>
			</div>
			<!---Mobile Section End---->
        </div>
       

    </div>
    

</div>
<!-- Turn off billing Modal -->
  <div class="modal" id="billingModal">
    <div class="modal-dialog prchspopup">
      <div class="modal-content">
      
        <!-- Modal Header -->
        <div class="modal-header bluemdlhdr">
        </div>
        
        <!-- Modal body -->
        <div class="modal-body sucssbody">
          <div class="purchased_logo">
              <img src="assets/images/bloomview-icon.png">
          </div>
          <div class="common modalText">
              <h6 class="sucssheading">Turn off recurring billing for Bloomview app</h6>
              <p class="tbldata text-center">By clicking this button, your plan will cancel at the end of the current <br>
              month and you will not be billed automatically for the next. </p>
          </div>
          <div class="common text-center mr-top-30">
              <button type="button" class="cancelbttn extndbtn" data-dismiss="modal"  onclick="window.location.href='manage_store.html';">Extend for 1 month</button>
              <button type="button" class="plcordrbtn wd-43" data-dismiss="modal"  onclick="window.location.href='manage_store.html';">Turn off billing </button>
          </div>
        </div>
        
       
        
      </div>
    </div>
  </div>
  

<!-- Turn off billing Modal -->

<!-- Change Admin User Modal -->
<div class="modal centerModalNew fade in" id="changeAdminUser">
    <div class="modal-dialog ">
    <div class="modal-content">    
    
    
    <!-- Modal body -->
    <div class="modal-body changeimagebody">
        <div class="common billingform ">
            <div class="changeimagediv text-center mr-top-60">
                
                <form [formGroup]="admin_select_form" (ngSubmit)="admin_select_submit()">
                    <h6 class="sucssheading clrgry text-left">Select Admin                    </h6>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <select class="ordrslct wd-70 newslct "class="form-control"
						(change)="SelectedAdmin($event.target.value)" formControlName="admin_id" >
						<option value="">Select Admin User</option>
						<option *ngFor="let user of AdminData" [value]="user.admin_user_id">
							{{user.first_name}} {{user.last_name}}
						</option>
                          </select>
                            <div *ngIf="admin_form_submit && admin_select_f.admin_id.invalid">
                                <span class="inputValidation" *ngIf="admin_select_f.admin_id.errors.required">Admin User is required.</span>
                            </div>
                          <span class="inputValidation">{{adminMessage}}</span>
                           
                        </div>
                    </div>
                   
                    <div class="common changenumberbttn text-left">
                        <button class="savebttn" type="submit" [disabled]="adminButtonActive ? false : true">Update</button>
                        <button class="cancelbttn close_s_admin" data-dismiss="modal">Close</button>
                      </div>
                      <div class="common text-success sccsmsgdiv" ></div>
                </form>
    
            </div>
        </div>
    
    </div>
</div>
</div>
</div>

    <!-- upgradePlan Modal -->
<div class="modal centerModalNew fade in" id="upgradePlan">
    <div class="modal-dialog ">
    <div class="modal-content">    
    
    
    <!-- Modal body -->
    <div class="modal-body changeimagebody">
        <div class="common billingform ">
            <div class="changeimagediv text-center mr-top-60">
                
                <form [formGroup]="subscription_form" (ngSubmit)="submit_subscription()">
                    <h6 class="sucssheading clrgry text-left">Select Plan                    </h6>
                        <div class="row">
                            <div class="form-group col-md-12">
                                
                            <select formControlName="package_type" class="ordrslct wd-70 newslct form-control mb-3"
						(change)="changePlanType($event.target.value)" >
						<option value="">Select Frequency</option>
						<option value="month">Month</option>
						<option value="year">Year</option>
                          </select>
                          <div *ngIf="subscriptionSubmitClick && subscription_f.package_type.invalid">
                            <span class="inputValidation" *ngIf="subscription_f.package_type.errors.required">Frequency is required.</span>
                        </div>
                            
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <select formControlName="package_id" class="ordrslct wd-70 newslct "class="form-control"
                            (change)="selectPackage($event.target.value)" >
                            <option value="">Select Plan</option>
                            <option *ngFor="let package of productPackage" [value]="package.id">
                                {{package.name}}-{{package.package_name}}(${{package.packagePrice}})
                            </option>
                            </select>
                          
                        <div *ngIf="subscriptionSubmitClick && subscription_f.package_id.invalid">
                            <span class="inputValidation" *ngIf="subscription_f.package_id.errors.required">Plan is required.</span>
                        </div>
                        <span *ngIf="planSuccessMessage" class="inputValidation success_msg">{{planSuccessMessage}}</span>
                            <span *ngIf="planErrorMessage" class="inputValidation error_msg">{{planErrorMessage}}</span>
                        </div>
                        
                    </div>
                    <div class="common changenumberbttn text-left">
                        <button class="savebttn">Update</button>
                        <button class="cancelbttn cancelbttn_plan" data-dismiss="modal">Close</button>
                      </div>
                      <div class="common text-success sccsmsgdiv" ></div>
                </form>
    
            </div>
        </div>
    
    </div>
</div>
</div>
</div>

<!-- Change payment card Modal -->
<div class="modal centerModalNew fade in" id="changeCard">
    <div class="modal-dialog ">
    <div class="modal-content">    
    
    
    <!-- Modal body -->
    <div class="modal-body changeimagebody">
        <div class="common billingform ">
            <div class="changeimagediv text-center mr-top-60">
                
                <form [formGroup]="card_form" (ngSubmit)="card_submit()">
                    <h6 class="sucssheading clrgry text-left">Select Card</h6>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <select formControlName="card_id" class="ordrslct wd-70 newslct "class="form-control"
						(change)="SelectedCard($event.target.value)" >
						<option value="">Select Card</option>
						<option *ngFor="let card of cardList" [value]="card.card_id">
							{{card.card_brand}} *{{card.card_last4}}
						</option>
                          </select>
                          <div *ngIf="card_form_submitted && card_f.card_id.invalid">
                            <span class="inputValidation" *ngIf="card_f.card_id.errors.required">Card is required.</span>
                            </div>

                            <span class="inputValidation">{{cardSelectMessage}}</span>
                        </div>
                        
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <a href="javascript:void(0)" (click) = "addNewCard()" class="boxpara pull-left" data-toggle="modal" data-target="#addCard">Add New Card</a>
                        </div>
                    </div>
                    <div class="common changenumberbttn text-left">
                        <button class="savebttn">Update</button>
                        <button class="cancelbttn close_card_mdl" data-dismiss="modal">Close</button>
                      </div>
                      <div class="common text-success sccsmsgdiv" ></div>
                </form>
    
            </div>
        </div>
    
    </div>
</div>
</div>
</div>

<!-- add payment card Modal -->
<div class="modal centerModalNew fade in" id="addCard">
    <div class="modal-dialog ">
    <div class="modal-content">    
    
    
    <!-- Modal body -->
    <div class="modal-body changeimagebody">
        <div class="common billingform addCard_div">
            <div class="changeimagediv text-center mr-top-60">
                
                <form [formGroup]="add_card_form" (ngSubmit)="add_card_submit()">
                    <h6 class="sucssheading clrgry text-left">Add New Card</h6>
                    <div class="common crditcrdfrm">
                        <div class="form-group">
                           <input formControlName="name" type="text" class="form-control" id="credit_name" placeholder="Enter name" >
                           <div *ngIf="add_card_submitted && add_card_f.name.invalid">
                            <span class="inputValidation" *ngIf="add_card_f.name.errors.required">Name is required.</span>
                            </div>
                        </div>
                        <div class="form-group">
                           <input formControlName="number" type="text" class="form-control" id="credit_number" placeholder="Enter Credit Number"  maxlength="16">
                           <div *ngIf="add_card_submitted && add_card_f.name.invalid">
                            <span class="inputValidation" *ngIf="add_card_f.name.errors.required">Credit Number is required.</span>
                            </div>
                        </div>
                        <div class="form-group row">
                           <div class="col-md-4 col-sm-4 col-xs-4">
                              <select id="expYear" class="pymntmthds form-control" placeholder="324" 
                                 autocomplete="off" formControlName="exp_year">
                                 <option value="">Select Year</option>
                                 <option *ngFor = "let year of yearList" value="{{year.value}}">{{year.year}}</option>
                              </select>
                              <div *ngIf="add_card_submitted && add_card_f.exp_year.invalid">
                                <span class="inputValidation" *ngIf="add_card_f.exp_year.errors.required">Card Expiry Year is required.</span>
                                </div>
                           </div>
                           <div class="col-md-4 col-sm-4 col-xs-4">
                              <select id="card_expiry_date" formControlName="exp_month" class="pymntmthds form-control" placeholder="324"
                                 autocomplete="off" >
                                 <option value="">Select Month</option>
                                 <option value="1">01</option>
                                 <option value="2">02</option>
                                 <option value="3">03</option>
                                 <option value="4">04</option>
                                 <option value="5">05</option>
                                 <option value="6">06</option>
                                 <option value="7">07</option>
                                 <option value="8">08</option>
                                 <option value="9">09</option>
                                 <option value="10">10</option>
                                 <option value="11">11</option>
                                 <option value="12">12</option>
                              </select>
                              <div *ngIf="add_card_submitted && add_card_f.exp_month.invalid">
                                <span class="inputValidation" *ngIf="add_card_f.exp_month.errors.required">Card Expiry Month is required.</span>
                                </div>
                           </div>
                           <div class="col-md-4 col-sm-4 col-xs-4">
                              <input type="text" class="form-control" placeholder="CVV"  maxlength="4" formControlName="cvv">
                              <div *ngIf="add_card_submitted && add_card_f.cvv.invalid">
                                <span class="inputValidation" *ngIf="add_card_f.cvv.errors.required">CVV is required.</span>
                                </div>
                           </div>
                        </div>
                        <span class="inputValidation">{{StripeCardEror}}</span>
                     </div>
                    
                    <div class="common changenumberbttn text-left">
                        <!-- <div *ngIf="buttonLoading else addCard">
                            <img src="assets/images/loading.gif" class="loading_gif"/>
                        </div>   
                        <ng-template #addCard> -->
                            <button class="savebttn" [disabled]="buttonLoading ? true : false">Add</button>
                        <!-- </ng-template> -->
                        <button class="cancelbttn close_card_mdl_add" data-dismiss="modal">Close</button>
                      </div>
                      <div class="common text-success sccsmsgdiv" ></div>
                </form>
    
            </div>
        </div>
    
    </div>
</div>
</div>
</div>
<!-- SCRIPTS -->
<script>
	$(document).ready(function(){
	  $(".crdtcrdslct").click(function(){
	    $(".crditcrdfrm").addClass("d-block");
	    $(".pyplfrm").removeClass("d-block");
	  });
	  $(".pyplslct").click(function(){
	    $(".pyplfrm").addClass("d-block");
	    $(".crditcrdfrm").removeClass("d-block");
	  });
	});
	</script>	
	<!-- SCRIPTS -->